import React from 'react';
import { Button, Col, Container, Row, Table } from 'react-bootstrap';
import fst from './lottery_assets/lot_box.svg';
import box from '../../assets/images/lottery/lotterybox.png';
import gift1 from './lottery_assets/lot_head1.svg';
import gift2 from './lottery_assets/lot_head2.svg';

import './lottery_styles/lotteryhead.css';

export default function LotteryHead() {
  return (
    <>
      <Container className='mt-5 mb-5 lottery'>
        <Row>
            <Col>
              <div className="lot_head">
                <div className="lot_head_content w-50 mx-auto text-start">
                 <h4 className='lot_open'>OPEN</h4>
                 <h1 className='lot_mystery'>MYSTERY BOX</h1>
                 <h2 className='lot_winning'>WITH YOUR FRIENDS WITH 100% WINNING RATE</h2>
                 <span>Time: 2022-08-14 ~ 2023-11-30</span>
                </div>
                <div className="lot_head_boxes">
                  <Row className='lot_head_box mt-5 mb-5'>
                   <Col xl={4}>
                    <div className='box_image mx-auto' style={{width:'90%'}}>
                    <div className="fst_box mt-3">
                    <div className="fst_box_img d-block">
                      <img src={box} alt="" className='rounded img-fluid fst_box_im' height={"auto"} />
                      <div className="lot_fst_btn w-50">
                      <Button className=''>INVITE</Button>
                    </div>
                    </div>
                    </div>
                    </div>
                   </Col>
                   <Col xl={4}>
                    <div className="scnd_box mt-3">
                    <Table responsive borderless className="scnd_box_table text-center">
                      <thead className="scnd_box_thead rounded-circle">
                        <tr>
                          <th colSpan={2}>MY REWARDS</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>TIME</td>
                          <td>REWARDS</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Table>
                    </div>
                  </Col>
                  <Col xl={4}>
                    <div className="thrd_box mt-3">
                    <div className="thrd_box_head text-center">
                      <span>NUMBER OF DRAWS</span>
                    </div>
                    <div className="third_box_content">
                      <div className="third_box_content1 d-flex flex-column justify-content-center align-items-center">
                        <div className="third_box_content1_img">
                          <img src={gift1} alt="" />
                        </div>
                        <div>
                          <span>REMAINING (MINE)</span>
                        </div>
                        <div>
                          <h3>354</h3>
                        </div>
                      </div>
                      <hr />
                      <div className="third_box_content2 d-flex flex-column justify-content-center align-items-center">
                        <div className="third_box_content1_img">
                          <img src={gift2} alt="" />
                        </div>
                        <span>OPENED (TOTAL USDT)</span>
                        <div><h3>354</h3></div>
                      </div>
                    </div>
                    </div>
                  </Col>
                  </Row>
                </div>
              </div>
            </Col>
        </Row>
      </Container>
    </>
  )
}
